// extracted by mini-css-extract-plugin
export default {"feeTable":"FeeExplanation_feeTable__XhFLb","headOrange":"FeeExplanation_headOrange__8Yw4T","dataRow":"FeeExplanation_dataRow__7hizA","column":"FeeExplanation_column__4pHEd"};